import type Intl from 'lean-intl';

declare global {
  const globalThis: WindowOrWorkerGlobalScope & {
    Intl: typeof Intl;
  };
}

// defined in SandboxRuntimeLite.ts
declare function importIntlPolyfill(): void;

globalThis.global = globalThis;
globalThis.Intl = new Proxy({} as Intl, {
  get: (_, p) => {
    // import the real polyfill async, and circuit break while we wait for it to initialize
    importIntlPolyfill();
    // if we didn't throw, return the requested field
    return (globalThis.Intl as unknown as { [key: string | symbol]: unknown })[p];
  },
});
